import RecommendationsSectionDetails from "./RecommendationsSectionDetails";
export default RecommendationsSectionDetails;
